import { useState, useContext } from 'react';
import { Popover, Portal } from '@chakra-ui/react';
import { PortalContainerContext } from './providers/chakra';

const VPopover = ({
  trigger,
  title,
  body,
  footer,
  showArrow = true,
  fitViewport = false,
  width,
  children = null,
  positioning: positioningProp,
  open: openProp,
  onOpenChange,
  defaultOpen,
  ...props
}) => {
  const portalContainerRef = useContext(PortalContainerContext);
  const [internalOpen, setInternalOpen] = useState(defaultOpen ?? false);
  const isControlled = openProp !== undefined;
  const open = isControlled ? openProp : internalOpen;
  const positioning = { strategy: 'fixed', ...positioningProp };

  const handleOpenChange = (details) => {
    if (!isControlled) {
      setInternalOpen(details.open);
    }

    onOpenChange?.(details);
  };

  const focusManagement = {
    autoFocus: false,
    returnFocusOnClose: false,
  };

  return (
    <Popover.Root
      {...props}
      open={open}
      onOpenChange={handleOpenChange}
      positioning={positioning}
      lazyMount
      {...focusManagement}
    >
      <Popover.Trigger asChild>
        <span role="presentation">{trigger}</span>
      </Popover.Trigger>
      <Portal container={portalContainerRef}>
        <Popover.Positioner>
          <Popover.Content
            width={width}
            maxHeight={fitViewport ? 'var(--available-height)' : undefined}
            display={fitViewport ? 'flex' : undefined}
            flexDirection={fitViewport ? 'column' : undefined}
            overflow={fitViewport ? 'hidden' : undefined}
          >
            {showArrow && <Popover.Arrow />}
            <Popover.Body
              flex={fitViewport ? '1' : undefined}
              overflowY={fitViewport ? 'auto' : undefined}
            >
              {title && <Popover.Title fontWeight="medium">{title}</Popover.Title>}
              {body || children}
            </Popover.Body>
            {footer && <Popover.Footer>{footer}</Popover.Footer>}
          </Popover.Content>
        </Popover.Positioner>
      </Portal>
    </Popover.Root>
  );
};

export default VPopover;
